import React, { useCallback, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { CloseOutlined, LocationOnOutlined } from '@mui/icons-material';
import ToastHandler from 'components/Toast-Handler/toast-handler';

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  paddingRight: theme.spacing(3),
}));

const DialogTitle = ({ children, isProcessing, toast, onClose }) => (
  <StyledDialogTitle>
    <Typography variant='subtitle1'>{children}</Typography>
    <Box display='flex' alignItems='center' gap={2}>
      {isProcessing && <CircularProgress style={{margin: '0px 50%'}} />}
      {toast && toast.type ? <ToastHandler toast={toast} type={toast.type} /> : ''}  { /*This needs to be included with all forms */}
      <IconButton
        aria-label="close"
        onClick={onClose}
        size="large">
        <CloseOutlined />
      </IconButton>
    </Box>
  </StyledDialogTitle>
);

export const useConfirmationDialog = () => {
  const [open, setOpen] = useState(false);
  const [resolveCallback, setResolveCallback] = useState(null);
  const [options, setOptions] = useState({ title: '', icon: null, content: '' });

  const confirm = useCallback(({ title, icon, content }) => {
    setOptions({title, icon, content});
    setOpen(true);

    return new Promise((resolve) => {
      setResolveCallback(() => resolve);
    });
  }, []);

  const handleClose = (selection) => {
    setOpen(false);
    if(resolveCallback)
      resolveCallback(selection);
  };

  const confirmationDialog = (
    <Dialog
      maxWidth={'sm'}
      fullWidth
      open={open}
      onClose={() => handleClose()}
    >
      <DialogTitle
        onClose={() => handleClose()}
      >
        {options.icon} {options.title}
      </DialogTitle>
      <Divider />
      <DialogContent>
        {options.content}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>No</Button>
        <Button onClick={() => handleClose(true)} color='secondary' variant='contained'>Yes</Button>
      </DialogActions>
    </Dialog>
  );

  return [confirm, confirmationDialog];
};